/* eslint-disable max-lines-per-function */
import React from 'react';
import {Menu} from 'antd';
import {Link} from 'react-router-dom';

import './index.less';

const {SubMenu} = Menu;

function Header({pathname}) {

    return (
        <div className="header-container">
            <div className="header-content">
                <a href="/home">
                    <img src="//i.gsxcdn.com/1609093770_ya9cb9ql.svg" alt="icon" />
                </a>
                <Menu
                    id="submenu"
                    mode="horizontal"
                    forceSubMenuRender
                >
                    <Menu.Item className={pathname.indexOf('home') > -1 ? 'home' : 'header-home'} key="1">
                        <Link to="/home">
                            Home
                        </Link>
                    </Menu.Item>
                    <SubMenu
                        className={pathname.indexOf('governance') > -1 ? 'governance' : ''}
                        title={<Link to="/governance">Governance</Link>}
                        key="governance"
                        popupClassName="control-sub-menu-governance"
                    >
                        <Menu.Item key="2">
                            <Link to="/governance/corporate">
                                Corporate Profile
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="3">
                            <Link to="/governance/board">
                                Board of Directors
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="4">
                            <Link to="/governance/documents">
                                Governance Documents
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                    <SubMenu
                        className={pathname.indexOf('news') > -1 ? 'news' : ''}
                        title={<Link to="/news">News&Events</Link>}
                        key="news"
                        popupClassName="control-sub-menu-news"
                    >
                        <Menu.Item key="5">
                            <Link to="/news/releases">
                                News Releases
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="6">
                            <Link to="/news/events">
                                Events
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="7">
                            <Link to="/news/agm">
                                AGM/EGM
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="8">
                            <Link to="/news/video">
                                Videos
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                    <SubMenu
                        className={pathname.indexOf('stock') > -1 ? 'news' : ''}
                        title={<Link to="/stock">Stock Infomation</Link>}
                        key="stock"
                        popupClassName="control-sub-menu-stock"
                    >
                        <Menu.Item key="9">
                            <Link to="/stock/chart">
                                Stock Quote & Chart
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="10">
                            <Link to="/stock/analyst">
                                Analyst Coverage
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                    <SubMenu
                        className={pathname.indexOf('financial') > -1 ? 'news' : ''}
                        title={<Link to="/financial">Financial Infomation</Link>}
                        key="financial"
                        popupClassName="control-sub-menu-financial"
                    >
                        <Menu.Item key="11">
                            <Link to="/financial/quarterly">
                                Quarterly Results
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="12">
                            <Link to="/financial/annual">
                                Annual Reports
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="13">
                            <Link to="/financial/sec">
                                SEC Filings
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                    <SubMenu
                        className={pathname.indexOf('contact') > -1 ? 'news' : ''}
                        title={<Link to="/contact">Contact Us</Link>}
                        key="contact"
                        popupClassName="control-sub-menu-contact"
                    >
                        <Menu.Item key="14">
                            <Link to="/contact/ir">
                                IR Contacts
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="15">
                            <Link to="/contact/investor">
                                Investor Alerts
                            </Link>
                        </Menu.Item>
                        <Menu.Item key="16">
                            <Link to="/contact/faq">
                                FAQ
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </div>
        </div>
    );
}

export default Header;
